import script from "./AssignDriverModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AssignDriverModal.vue?vue&type=script&setup=true&lang=js"

import "./AssignDriverModal.vue?vue&type=style&index=0&id=224fd56e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-224fd56e"]])

export default __exports__